
import {fetchOrUpdateUserStatus, getAPIKeyFunc, refreshAPIKeyFunc} from '../components/Membership.js';

import {CallToJoin} from '../components/CallsToAction.js';
import React from 'react';
import { Container, Row, Col} from 'react-bootstrap';
import { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import { signOut} from '@aws-amplify/auth';
// import { BuyButton } from '../components/BuyButtons.js';
import PricingPage from '../components/PricingPage.js';
import StripeStatusTable from '../components/StripeStatusTable.js';
import SiteCard from '../components/SiteCard.js';
import { Link } from 'react-router-dom';






import { useAuthenticator } from '@aws-amplify/ui-react';



function ManageSubscription({ userEmail }) {
  // Handler function to open the link
  const handleButtonClick = () => {
    // Open the Stripe billing link in a new tab
    window.open(process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL+'?prefilled_email='+userEmail, '_blank');
  };

  return (
    // Button to manage subscription, onClick event opens the Stripe billing page
    <button onClick={handleButtonClick} className="otta-button">
      Manage Subscription
    </button>
  );
}

const APIKeyDisplay = ({ apiKey, isOpen, onToggle, copySuccess, onCopy, onRefresh, isRefreshing }) => {
    return (
        <div className="h-100">
            <br />
            <div className="d-flex flex-column">
                <div className="d-flex justify-content-between mb-3">
                    <button 
                        className="btn btn-primary" 
                        onClick={onToggle}
                        aria-expanded={isOpen}
                    >
                        {isOpen ? 'Hide API Key' : 'Show API Key'}
                    </button>
                    
                    <button 
                        className={`btn btn-warning ${isRefreshing ? 'disabled' : ''}`}
                        onClick={onRefresh}
                        disabled={isRefreshing}
                    >
                        {isRefreshing ? 'Refreshing...' : 'Refresh API Key'}
                    </button>
                </div>
                
                {isOpen && (
                    <div className="card card-body">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <small className="text-muted">API Key:</small>
                            <button 
                                className={`btn btn-sm ${copySuccess ? 'btn-success' : 'btn-secondary'}`}
                                onClick={onCopy}
                            >
                                {copySuccess ? 'Copied!' : 'Copy Key'}
                            </button>
                        </div>
                        <code className="text-black text-sm break-all">
                            {apiKey}
                        </code>
                    </div>
                )}
            </div>
        </div>
    );
};

const Subscription = ({ stripeStatus, userEmail, planName }) => {

  if (!stripeStatus) {
    return (
<div style={{ 
    justifyContent: 'center', 
    alignItems: 'center', 
    textAlign: 'center',
    height: '100%',  // Ensure it takes full height of its container
    width: '100%'    // Ensure it takes full width of its container
}}>
  {/*  header={'SUBSCRIPTION DETAILS'} title = {'Support ottaproperty.co.uk'} content={<BuyButton userEmail={userEmail} />}></SiteCard> */}
  <SiteCard header={'SUBSCRIPTION DETAILS'} title = {'Support ottaproperty.co.uk'} content={<PricingPage />}></SiteCard>
</div>



    )
  }

  const SubscriptionDetails = (    <div>
      <Row>
    <Col xs={12} md={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '1rem' , marginBottom: '1rem'}}>
      <ManageSubscription userEmail={userEmail} />
    </Col>
    <Col xs={12} md={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '1rem' , marginBottom: '1rem'}}>
      <p>Clicking this button will open a new window to the stripe billing page.
      ottaproperty.co.uk does not store any payment information.
      </p>
    </Col>
  </Row>
  <Row>
    <div>
      <StripeStatusTable stripeStatus={stripeStatus} planName={planName} />
    </div>
    </Row>

  <Col xs={12} md={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
  <h3>Thanks for your support</h3>
  </Col>


</div>
  );

  // Check if subscription is active and render appropriate message
  return (
    <SiteCard header={'SUBSCRIPTION DETAILS'} title = {'Subscription Details'} content={SubscriptionDetails} />

    
  );
};


const handleSignOut = async () => {
  try {
    await signOut();
  } catch (error) {
    console.error('Error signing out: ', error);
  }
};

const AccountPage = () => {
  const { user, isLoadingUser } = useAuthenticator();
  const [userEmail, setUserEmail] = useState(null); // State to store user email
  const [status, setStatus] = useState(null);
  const [stripeStatus, setStripeStatus] = useState(null);
  const [planName, setPlanName] = useState('basic'); // Default plan name
  const [, setStripeSubscription] = useState(null); // State to store user status [null, loading, error, data
  const lastUserIdRef = useRef(null); // Ref to track the last user id processed
  const [apiKey, setApiKey] = useState('');
  const [isApiKeyOpen, setIsApiKeyOpen] = useState(false);
  const [apiKeyCopySuccess, setApiKeyCopySuccess] = useState(false);
  const [isTokenLoading, setIsTokenLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);


  useEffect(() => {
      const getApiKey = async () => {
          try {

              
              if (user?.signInDetails?.loginId) {

                  
                  const apiKeyValue = await getAPIKeyFunc(user.signInDetails.loginId);

                  
                  if (apiKeyValue) {
                      setApiKey(apiKeyValue);
                  }
              } else {

              }
          } catch (error) {
              return null;
          } finally {
              // Always set loading to false, regardless of success or failure
              setIsTokenLoading(false);
          }
      };

      if (user && !isLoadingUser) {
          getApiKey();
      }
  }, [user, isLoadingUser]);

  useEffect(() => {
    const processUserStatus = async () => {
      // Only process if user exists, status is null, and user ID has changed
      if (user && status === null && lastUserIdRef.current !== user.userId) {
        try {
          const result = await fetchOrUpdateUserStatus(user);
          setStatus(result);
            if (result.stripe && result.stripe.stripe_sub_status === 'active') {
              setStripeSubscription(true);
          }

          if (result.stripe) {
            setStripeStatus(result.stripe);
          }
          if (result.email) {
              setUserEmail(result.email);
          }
          if (result.plan_name) {
              setPlanName(result.plan_name);
          }
          lastUserIdRef.current = user.userId; // Update last processed user id
        } catch (error) {
          // Suppress error logging for undefined stripe property
        }
      }
    };
    processUserStatus();
  }, [user, status]);

 const copyApiKey = async () => {
        try {
            await navigator.clipboard.writeText(apiKey);
            setApiKeyCopySuccess(true);
            setTimeout(() => setApiKeyCopySuccess(false), 2000);
        } catch (err) {
            console.error('Failed to copy API key:', err);
        }
    };
  if (isLoadingUser) {
    return (
      <div>
        <p>Loading...</p>
      </div>
    );
  }

  const refreshApiKey = async () => {
      if (!user?.signInDetails?.loginId) return;
      
      setIsRefreshing(true);
      try {
        // Call your GraphQL mutation
        await refreshAPIKeyFunc(user.signInDetails.loginId);
                // Now fetch the new API key
        const newApiKey = await getAPIKeyFunc(user.signInDetails.loginId);
        if (newApiKey) {
            setApiKey(newApiKey);
        }
      } catch (error) {
        console.error('Error refreshing API key:', error);
      } finally {
        setIsRefreshing(false);
      }
    };


  if (!user) {
    return (
      <CallToJoin />
    );
  }

  const accountContent = (
    <div style={{ textAlign: 'left' , height: '100%'}}>
            <p>Thanks for creating an account! Here's what you can access:</p>
            <ul>
            <li><a href="https://forms.gle/2G8ufLwat9qS8Fh48">Share feedback through our <strong>Feedback Form</strong> to help us improve.</a></li>
            <li>Stay informed with updates and new features.</li>
            </ul>

            <hr />

            <h5>Free Account Benefits:</h5>
            <ul>
                <li>Limited <Link to="/machine-learning-property-price-predictor">ML Predictor</Link> access (3 predictions/day)</li>
                <li><Link to="/map">Interactive Map</Link> with regional-level detail</li>
                <li><Link to="/map/sqm">Price per SQM Map</Link> with regional-level detail</li>
            </ul>

            <hr />

            <h5>Subscriber Benefits:</h5>
            <p><b>Basic Plan</b> (£3.99/month):</p>
            <Container>
                <ul>
                    <li><b>Unlimited</b> <Link to="/machine-learning-property-price-predictor">ML Predictor</Link> access</li>
                    <li>Download and export prediction history</li>
                    <li>Full access to <Link to="/trends">Property Trends</Link> (ML Index & Raw Data)</li>
                    <li><Link to="/map">Interactive Map</Link> with <b>street and postcode-level detail</b></li>
                    <li><Link to="/map/sqm">Price per SQM Map</Link> with <b>full zoom access</b></li>
                    <li>API access (10 calls/day)</li>
                </ul>
            </Container>

            <p><b>Pro Plan</b> (£100/month):</p>
            <Container>
                <ul>
                    <li>Everything in Basic, plus:</li>
                    <li>Higher API limits (300 calls/day)</li>
                    <li>Priority support</li>
                </ul>
            </Container>

        <Container style={{ textAlign: 'center' ,marginTop: '1rem' , marginBottom: '1rem'}}>
                <button className="otta-button" onClick={handleSignOut}>Sign Out</button>
              </Container>
    </div>


  );




  return (

    



  <Container >

    
<Col xs={12} lg={10} xl={8} className="mx-auto">
    <SiteCard header={'WELCOME'} title={'Welcome to your account'} content={accountContent} />
    
      </Col>


<Col xs={12} lg={10} xl={8} className="mx-auto">
        <Subscription stripeStatus={stripeStatus} userEmail={userEmail} planName={planName} />
      </Col>

<Col xs={12} lg={10} xl={8} className="mx-auto">
  <SiteCard 
    header={'API ACCESS'} 
    content={
      <>
        {isTokenLoading ? (
          <div>Loading token...</div>
        ) : stripeStatus?.stripe_sub_status === 'active' ? (
          <APIKeyDisplay 
            apiKey={apiKey}
            isOpen={isApiKeyOpen}
            onToggle={() => setIsApiKeyOpen(!isApiKeyOpen)}
            copySuccess={apiKeyCopySuccess}
            onCopy={copyApiKey}
            onRefresh={refreshApiKey}
            isRefreshing={isRefreshing}
          />
        ) : (
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100%', 
            padding: '1rem' 
          }}>
            <p>API access is available for supporters only. Please subscribe to access your API key.</p>

          </div>
        )}
      </>
    }
  />
</Col>


    


    
  </Container>
  );
}

export default AccountPage;